<template>
  <div class="flex w-full h-screen chat bg-[#2e2e2e]">
    <div class="w-[35%] flex">
      <div
        class=" w-[15%] py-5 h-full bg-[#2e2e2e] flex flex-col items-center px-1 justify-between">
        <router-link to="/chat" class="w-full py-1 h-[40px] relative">
          <svg
            class="
              fill-[#ffffffbd]
              absolute
              left-1/2
              top-1/2
              -translate-y-1/2 -translate-x-1/2S
            "
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 24 24"
          >
            <path
              d="M7 3C5.897 3 5 3.897 5 5L5 8L2 11L7 11L20 11C21.103 11 22 10.103 22 9L22 5C22 3.897 21.103 3 20 3L7 3 z M 7 13C5.897 13 5 13.897 5 15L5 18L2 21L7 21L20 21C21.103 21 22 20.103 22 19L22 15C22 13.897 21.103 13 20 13L7 13 z"
            />
          </svg>
        </router-link>
        <div
          class="w-full py-1 h-[40px] relative cursor-pointer"
          @click="modals('allchatusers')"
        >
          <svg
            class="
              fill-[#ffffffbd]
              absolute
              left-1/2
              top-1/2
              -translate-y-1/2 -translate-x-1/2
            "
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
          >
            <path
              d="M16 8C13.25 8 11 10.25 11 13C11 14.515625 11.707031 15.863281 12.78125 16.78125C11.714844 17.339844 10.78125 18.183594 10.125 19.1875C9.769531 18.671875 9.300781 18.195313 8.78125 17.84375C9.523438 17.117188 10 16.113281 10 15C10 12.800781 8.199219 11 6 11C3.800781 11 2 12.800781 2 15C2 16.113281 2.476563 17.117188 3.21875 17.84375C1.886719 18.746094 1 20.285156 1 22L3 22C3 20.34375 4.34375 19 6 19C7.65625 19 9 20.34375 9 22L9 23L11 23C11 20.246094 13.246094 18 16 18C18.753906 18 21 20.246094 21 23L23 23L23 22C23 20.34375 24.34375 19 26 19C27.65625 19 29 20.34375 29 22L31 22C31 20.285156 30.113281 18.746094 28.78125 17.84375C29.523438 17.117188 30 16.113281 30 15C30 12.800781 28.199219 11 26 11C23.800781 11 22 12.800781 22 15C22 16.113281 22.476563 17.117188 23.21875 17.84375C22.699219 18.195313 22.230469 18.671875 21.875 19.1875C21.21875 18.183594 20.285156 17.339844 19.21875 16.78125C20.292969 15.863281 21 14.515625 21 13C21 10.25 18.75 8 16 8 Z M 16 10C17.667969 10 19 11.332031 19 13C19 14.667969 17.667969 16 16 16C14.332031 16 13 14.667969 13 13C13 11.332031 14.332031 10 16 10 Z M 6 13C7.117188 13 8 13.882813 8 15C8 16.117188 7.117188 17 6 17C4.882813 17 4 16.117188 4 15C4 13.882813 4.882813 13 6 13 Z M 26 13C27.117188 13 28 13.882813 28 15C28 16.117188 27.117188 17 26 17C24.882813 17 24 16.117188 24 15C24 13.882813 24.882813 13 26 13Z"
            />
          </svg>
        </div>
        <div class="flex flex-col items-center justify-center w-full">
          <div class="relative w-full mb-4">
            <div class="w-[30px] cursor-pointer m-auto" @click="modals('pop')">
              <svg
                class="fill-[#ffffffbd]"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 48 48"
              >
                <path
                  d="M24 4C22.423103 4 20.902664 4.1994284 19.451172 4.5371094 A 1.50015 1.50015 0 0 0 18.300781 5.8359375L17.982422 8.7382812C17.878304 9.6893592 17.328913 10.530853 16.5 11.009766C15.672739 11.487724 14.66862 11.540667 13.792969 11.15625L13.791016 11.15625L11.125 9.9824219 A 1.50015 1.50015 0 0 0 9.4257812 10.330078C7.3532865 12.539588 5.7626807 15.215064 4.859375 18.201172 A 1.50015 1.50015 0 0 0 5.4082031 19.845703L7.7734375 21.580078C8.5457929 22.147918 9 23.042801 9 24C9 24.95771 8.5458041 25.853342 7.7734375 26.419922L5.4082031 28.152344 A 1.50015 1.50015 0 0 0 4.859375 29.796875C5.7625845 32.782665 7.3519262 35.460112 9.4257812 37.669922 A 1.50015 1.50015 0 0 0 11.125 38.015625L13.791016 36.841797C14.667094 36.456509 15.672169 36.511947 16.5 36.990234C17.328913 37.469147 17.878304 38.310641 17.982422 39.261719L18.300781 42.164062 A 1.50015 1.50015 0 0 0 19.449219 43.460938C20.901371 43.799844 22.423103 44 24 44C25.576897 44 27.097336 43.800572 28.548828 43.462891 A 1.50015 1.50015 0 0 0 29.699219 42.164062L30.017578 39.261719C30.121696 38.310641 30.671087 37.469147 31.5 36.990234C32.327261 36.512276 33.33138 36.45738 34.207031 36.841797L36.875 38.015625 A 1.50015 1.50015 0 0 0 38.574219 37.669922C40.646713 35.460412 42.237319 32.782983 43.140625 29.796875 A 1.50015 1.50015 0 0 0 42.591797 28.152344L40.226562 26.419922C39.454197 25.853342 39 24.95771 39 24C39 23.04229 39.454197 22.146658 40.226562 21.580078L42.591797 19.847656 A 1.50015 1.50015 0 0 0 43.140625 18.203125C42.237319 15.217017 40.646713 12.539588 38.574219 10.330078 A 1.50015 1.50015 0 0 0 36.875 9.984375L34.207031 11.158203C33.33138 11.54262 32.327261 11.487724 31.5 11.009766C30.671087 10.530853 30.121696 9.6893592 30.017578 8.7382812L29.699219 5.8359375 A 1.50015 1.50015 0 0 0 28.550781 4.5390625C27.098629 4.2001555 25.576897 4 24 4 z M 24 7C24.974302 7 25.90992 7.1748796 26.847656 7.3398438L27.035156 9.0644531C27.243038 10.963375 28.346913 12.652335 30 13.607422C31.654169 14.563134 33.668094 14.673009 35.416016 13.904297L37.001953 13.207031C38.219788 14.669402 39.183985 16.321182 39.857422 18.130859L38.451172 19.162109C36.911538 20.291529 36 22.08971 36 24C36 25.91029 36.911538 27.708471 38.451172 28.837891L39.857422 29.869141C39.183985 31.678818 38.219788 33.330598 37.001953 34.792969L35.416016 34.095703C33.668094 33.326991 31.654169 33.436866 30 34.392578C28.346913 35.347665 27.243038 37.036625 27.035156 38.935547L26.847656 40.660156C25.910002 40.82466 24.973817 41 24 41C23.025698 41 22.09008 40.82512 21.152344 40.660156L20.964844 38.935547C20.756962 37.036625 19.653087 35.347665 18 34.392578C16.345831 33.436866 14.331906 33.326991 12.583984 34.095703L10.998047 34.792969C9.7799772 33.330806 8.8159425 31.678964 8.1425781 29.869141L9.5488281 28.837891C11.088462 27.708471 12 25.91029 12 24C12 22.08971 11.087719 20.290363 9.5488281 19.160156L8.1425781 18.128906C8.8163325 16.318532 9.7814501 14.667839 11 13.205078L12.583984 13.902344C14.331906 14.671056 16.345831 14.563134 18 13.607422C19.653087 12.652335 20.756962 10.963375 20.964844 9.0644531L21.152344 7.3398438C22.089998 7.1753403 23.026183 7 24 7 z M 24 16C19.599487 16 16 19.59949 16 24C16 28.40051 19.599487 32 24 32C28.400513 32 32 28.40051 32 24C32 19.59949 28.400513 16 24 16 z M 24 19C26.779194 19 29 21.220808 29 24C29 26.779192 26.779194 29 24 29C21.220806 29 19 26.779192 19 24C19 21.220808 21.220806 19 24 19 z"
                />
              </svg>
            </div>
            <div
              class="
                absolute
                bg-[#2e2e2e]
                h-[400px]
                w-[500px]
                z-[3]
                left-[100%]
                bottom-0
                rounded-md
                shadow-[-10px_10px_30px_rgba(0,0,0,0.1)]
                overflow-hidden
                flex
                pointer-events-none
                opacity-0
                -translate-y-5
                duration-700
              "
              :class="{ popup: isActive }"
            >
              <div class="w-[35%] px-5 py-3">
                <div class=" flex items-center p-1 rounded-md w-full mb-3 hover:bg-[#424242] duration-200 cursor-pointer">
                  <div class="w-6 mr-3">
                    <svg
                      class="fill-white"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 50 50"
                    >
                      <path
                        d="M37 0L36.400391 3.1992188C36.100391 3.2992188 35.700391 3.3996094 35.400391 3.5996094L32.699219 1.6992188L29.699219 4.6992188L31.5 7.1992188C31.4 7.5992188 31.199609 7.9007812 31.099609 8.3007812L28 8.8007812L28 13L31.099609 13.5C31.199609 13.8 31.3 14.2 31.5 14.5L29.699219 17.199219L32.699219 20.199219L35.400391 18.400391C35.800391 18.600391 36.1 18.700781 36.5 18.800781L37 22L41.099609 22L41.699219 18.900391C41.999219 18.800391 42.299219 18.7 42.699219 18.5L45.400391 20.300781L48.400391 17.300781L46.5 14.699219C46.7 14.299219 46.800391 13.899609 46.900391 13.599609L50 13L50 8.8007812L46.800781 8.3007812C46.700781 8.0007812 46.600391 7.6007812 46.400391 7.3007812L48.199219 4.5996094L45.300781 1.6992188L42.699219 3.5996094C42.399219 3.3996094 41.999219 3.2992188 41.699219 3.1992188L41.199219 0L37 0 z M 38.699219 2L39.5 2L39.900391 4.6992188L40.5 4.9003906C41.1 5.1003906 41.699219 5.2996094 42.199219 5.5996094L42.800781 6L45.099609 4.3007812L45.599609 4.8007812L44 7.0996094L44.300781 7.5996094C44.600781 8.1996094 44.8 8.8003906 45 9.4003906L45.199219 10L48 10.400391L48 11.199219L45.300781 11.800781L45.099609 12.400391C44.899609 13.000391 44.700391 13.599609 44.400391 14.099609L44 14.699219L45.699219 17L45.099609 17.599609L42.800781 16L42.300781 16.300781C41.700781 16.600781 41.1 16.8 40.5 17L39.900391 17.199219L39.400391 20L38.599609 20L38.199219 17.300781L37.599609 17.099609C36.999609 16.899609 36.400391 16.700391 35.900391 16.400391L35.300781 16L32.900391 17.599609L32.300781 17L33.900391 14.699219L33.599609 14.199219C33.299609 13.599219 33.100391 12.900391 32.900391 12.400391L32.699219 11.800781L30 11.300781L30 10.5L32.800781 10L32.900391 9.3007812C33.000391 8.8007812 33.2 8.1992188 33.5 7.6992188L33.900391 7.1992188L32.300781 4.9003906L32.900391 4.3007812L35.199219 5.9003906L35.699219 5.6992188C36.399219 5.3992188 36.999609 5.1003906 37.599609 4.9003906L38.199219 4.8007812L38.699219 2 z M 39 6.9003906C36.8 6.9003906 35 8.7003906 35 10.900391C35 13.100391 36.8 14.900391 39 14.900391C41.2 14.900391 43 13.200391 43 10.900391C43 8.7003906 41.2 6.9003906 39 6.9003906 z M 8 8C5.794 8 4 9.794 4 12L4 34C4 34.732221 4.2118795 35.409099 4.5566406 36L2 36 A 1.0001 1.0001 0 0 0 1 37C1 39.749516 3.2504839 42 6 42L44 42C46.749516 42 49 39.749516 49 37 A 1.0001 1.0001 0 0 0 48 36L45.443359 36C45.788121 35.409099 46 34.732221 46 34L46 21.943359C45.367 22.349359 44.702 22.708 44 23L44 34C44 35.103 43.103 36 42 36L8 36C6.897 36 6 35.103 6 34L6 12C6 10.897 6.897 10 8 10L26.050781 10C26.102781 9.317 26.208328 8.65 26.361328 8L8 8 z M 39 9C40.1 9 41 9.8 41 11C41 12.1 40.1 13 39 13C37.9 13 37 12.1 37 11C37 9.9 37.9 9 39 9 z M 3.4121094 38L8 38L42 38L46.587891 38C46.150803 39.112465 45.275852 40 44 40L6 40C4.7241482 40 3.8491966 39.112465 3.4121094 38 z"
                      />
                    </svg>
                  </div>
                  <h3 class="text-xs text-white">General</h3>
                </div>
                <div
                  class="
                    flex
                    items-center
                    p-1
                    rounded-md
                    w-full
                    mb-3
                    hover:bg-[#424242]
                    duration-200
                    cursor-pointer
                  "
                >
                  <div class="w-6 mr-3">
                    <svg
                      class="fill-white"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 128 128"
                    >
                      <path
                        d="M64 27C51.3 27 41 37.3 41 50C41 62.7 51.3 73 64 73C76.7 73 87 62.7 87 50C87 37.3 76.7 27 64 27 z M 64 33C73.4 33 81 40.6 81 50C81 59.4 73.4 67 64 67C54.6 67 47 59.4 47 50C47 40.6 54.6 33 64 33 z M 64 81C47.6 81 32.400781 89.899609 24.300781 104.09961C23.500781 105.49961 24 107.39922 25.5 108.19922C26 108.49922 26.5 108.59961 27 108.59961C28 108.59961 29.099609 108.09961 29.599609 107.09961C36.599609 94.699609 49.8 87 64 87C78.2 87 91.4 94.699609 98.5 107.09961C99.3 108.49961 101.19961 108.99922 102.59961 108.19922C103.99961 107.39922 104.49922 105.49961 103.69922 104.09961C95.599219 89.899609 80.4 81 64 81 z"
                      />
                    </svg>
                  </div>
                  <h3 class="text-xs text-white">Profile</h3>
                </div>
              </div>
              <div class="w-[65%] px-5 py-3 bg-[#424242]">
                <h2 class="text-white font-lg">General</h2>
                <div
                  @click="logout"
                  class="
                    px-3
                    py-1
                    bg-[#686868]
                    shadow-md
                    text-[#cccccf]
                    w-fit
                    cursor-pointer
                    mt-4
                    rounded-md
                  "
                >
                  Logout
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              w-[35px]
              h-[35px]
              rounded-full
              overflow-hidden
              relative
              bg-[#4b4a4a]
              cursor-pointer
            "
            @click="modals('myprofile')"
          >
            <img
              v-if="active"
              :src="require('@/assets/profiles/' + loggeduser.profilepic)"
              class="absolute object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
      <div class="w-[85%] bg-[#2b2b2b] relative h-full chats overflow-y-scroll">
        <div
          class="
            absolute
            z-[3]
            w-full
            h-full
            bg-[#2b2b2b]
            pointer-events-none
            opacity-0
            -translate-x-5
            duration-500
            px-5
            py-4
          "
          :class="{ popupx: chatusers }"
        >
          <div class="flex items-center mb-7">
            <div class="w-5 mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 30 30"
                fill="#FFFFFF"
              >
                <path
                  d="M15 3C13.307 3 11.817109 3.8458125 10.912109 5.1328125C9.3621094 4.8628125 7.712625 5.318625 6.515625 6.515625C5.318625 7.712625 4.8628125 9.3631094 5.1328125 10.912109C3.8458125 11.817109 3 13.307 3 15C3 16.693 3.8458125 18.182891 5.1328125 19.087891C4.8628125 20.637891 5.318625 22.287375 6.515625 23.484375C7.712625 24.681375 9.3631094 25.137187 10.912109 24.867188C11.817109 26.154187 13.307 27 15 27C16.693 27 18.182891 26.154188 19.087891 24.867188C20.637891 25.137187 22.287375 24.681375 23.484375 23.484375C24.681375 22.287375 25.137187 20.636891 24.867188 19.087891C26.154187 18.182891 27 16.693 27 15C27 13.307 26.154188 11.817109 24.867188 10.912109C25.137187 9.3621094 24.681375 7.712625 23.484375 6.515625C22.287375 5.318625 20.636891 4.8628125 19.087891 5.1328125C18.182891 3.8458125 16.693 3 15 3 z M 21 10C21.25575 10 21.511531 10.097469 21.707031 10.292969C22.098031 10.683969 22.098031 11.316031 21.707031 11.707031L14.146484 19.267578C13.958484 19.455578 13.704453 19.560547 13.439453 19.560547C13.174453 19.560547 12.919422 19.455578 12.732422 19.267578L9.2792969 15.814453C8.8882969 15.423453 8.8882969 14.791391 9.2792969 14.400391C9.6702969 14.009391 10.302359 14.009391 10.693359 14.400391L13.439453 17.146484L20.292969 10.292969C20.488469 10.097469 20.74425 10 21 10 z"
                  fill="#FFFFFF"
                />
              </svg>
            </div>
            <h1 class="tracking-[0.15rem] text-white text-sm">ChatApp</h1>
          </div>
          <h2 class="mb-4 text-white">All Users</h2>
          <input
            type="text"
            placeholder="Search....."
            v-model="usersearch"
            class="
              mb-3
              w-full
              border-none
              outline-none
              bg-[#333]
              p-[.5rem_1rem]
              text-sm
              rounded-md
              text-[#8f9198]
              placeholder:text-[#7d7e83]
            "
          />
          <div class="w-full h-full" v-if="allusers">
            <TransitionGroup name="semess">
              <div
                v-for="user in allusers"
                :key="user.id"
                @click="vothersprofile('stranger', user)"
                class="
                  flex
                  justify-between
                  hover:bg-[#2e2e2e]
                  duration-200
                  mb-2
                  p-2
                  rounded-md
                  cursor-pointer
                "
              >
                <div class="flex items-center">
                  <div
                    class="
                      w-[40px]
                      h-[40px]
                      rounded-full
                      overflow-hidden
                      mr-4
                      relative
                      bg-[#4b4a4a]
                    "
                  >
                    <img
                      :src="require('@/assets/profiles/' + user.profilepic)"
                      class="absolute object-cover w-full h-full"
                    />
                  </div>
                  <div>
                    <h2 class="mb-1 text-sm text-white">{{ user.names }}</h2>
                    <div class="">
                      <p
                        class="text-xs text-[#8f9198] truncate w-[250px]"
                        :alt="user.status"
                      >
                        {{ user.status }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </TransitionGroup>
          </div>
        </div>
        <div
          v-if="active"
          class="
            absolute
            z-[3]
            w-full
            h-full
            bg-[#2b2b2b]
            pointer-events-none
            opacity-0
            -translate-x-5
            duration-500
          "
          :class="{ popupx: maprofile }"
        >
          <div class="w-full h-[150px] relative">
            <div class="absolute z-[1] w-full h-full bg-[#2525254b]"></div>
            <div
              class="
                absolute
                w-[30px]
                h-[30px]
                rounded-full
                bg-[#2b2b2b]
                top-3
                right-3
                z-[1]
                cursor-pointer
              "
            >
              <svg
                class="
                  absolute
                  fill-[#ffffffb0]
                  w-[60%]
                  h-[60%]
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
              >
                <path
                  d="M19.171875 2C18.448125 2 17.724375 2.275625 17.171875 2.828125L16 4L20 8L21.171875 6.828125C22.275875 5.724125 22.275875 3.933125 21.171875 2.828125C20.619375 2.275625 19.895625 2 19.171875 2 z M 14.5 5.5L3 17L3 21L7 21L18.5 9.5L14.5 5.5 z"
                />
              </svg>
            </div>
            <img
              :src="require('@/assets/coverpic/' + loggeduser.coverpic)"
              class="absolute object-cover w-full h-full"
              draggable="false"
            />
            <div
              class="
                absolute
                -translate-x-1/2
                w-[90px]
                h-[90px]
                -translate-y-1/2
                rounded-full
                top-full
                left-1/2
                z-[5]
              "
            >
              <div
                class="
                  w-full
                  h-full
                  border-4 border-[#2b2b2b]
                  rounded-full
                  overflow-hidden
                  absolute
                "
              >
                <img
                  :src="require('@/assets/profiles/' + loggeduser.profilepic)"
                  class="absolute object-cover w-full h-full"
                  draggable="false"
                />
              </div>
              <div
                class="
                  absolute
                  w-[30px]
                  h-[30px]
                  border border-gray-600
                  rounded-full
                  bg-[#2b2b2b]
                  bottom-0
                  right-0
                  z-10
                  cursor-pointer
                "
              >
                <svg
                  class="
                    absolute
                    fill-[#ffffffb0]
                    w-[60%]
                    h-[60%]
                    left-1/2
                    top-1/2
                    -translate-x-1/2 -translate-y-1/2
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 26 26"
                >
                  <path
                    d="M10.5 3C9.789063 3 9.320313 3.289063 9.09375 3.6875L7.8125 6L6 6C6 5.449219 5.550781 5 5 5L3 5C2.449219 5 2 5.449219 2 6L2 6.1875C0.835938 6.601563 0 7.695313 0 9L0 19.125C0 21.816406 2.183594 24 4.875 24L21.125 24C23.816406 24 26 21.816406 26 19.125L26 10.875C26 8.183594 23.816406 6 21.125 6L20.1875 6L18.90625 3.6875C18.679688 3.289063 18.179688 3 17.5 3 Z M 4 6.5C4.828125 6.5 5.5 7.171875 5.5 8C5.5 8.828125 4.828125 9.5 4 9.5C3.171875 9.5 2.5 8.828125 2.5 8C2.5 7.171875 3.171875 6.5 4 6.5 Z M 14 6.9375C17.898438 6.9375 21.0625 10.101563 21.0625 14C21.0625 17.898438 17.898438 21.0625 14 21.0625C10.101563 21.0625 6.9375 17.902344 6.9375 14C6.9375 10.097656 10.101563 6.9375 14 6.9375 Z M 14 9.1875C11.34375 9.1875 9.1875 11.34375 9.1875 14C9.1875 16.65625 11.34375 18.8125 14 18.8125C16.65625 18.8125 18.8125 16.65625 18.8125 14C18.8125 11.34375 16.65625 9.1875 14 9.1875Z"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="w-full py-1 mt-12">
            <div class="m-auto w-fit">
              <h2 class="text-lg text-[#8f9198] tracking-wider capitalize">
                {{ loggeduser.names }}
              </h2>
            </div>
          </div>
          <div class="w-full mt-2">
            <div class="w-full border-t border-[#474747]">
              <div
                class="flex items-center justify-between px-4 py-2 cursor-pointer "
                @click="paccordion('pinfo')"
              >
                <div class="flex items-center">
                  <div class="relative w-[30px] h-[30px] cursor-pointer mr-4">
                    <svg
                      class="
                        absolute
                        fill-[#ffffffb0]
                        h-[80%]
                        w-[80%]
                        left-1/2
                        top-1/2
                        -translate-x-1/2 -translate-y-1/2
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 30 30"
                    >
                      <path
                        d="M15 3C11.686 3 9 5.686 9 9L9 10C9 13.314 11.686 16 15 16C18.314 16 21 13.314 21 10L21 9C21 5.686 18.314 3 15 3 z M 14.998047 19C10.992047 19 5.8520469 21.166844 4.3730469 23.089844C3.4590469 24.278844 4.329125 26 5.828125 26L24.169922 26C25.668922 26 26.539 24.278844 25.625 23.089844C24.146 21.167844 19.004047 19 14.998047 19 z"
                      />
                    </svg>
                  </div>
                  <h3 class="text-sm text-[#ffffffb0]">Personal Info</h3>
                </div>
                <svg
                  class="w-[15px] h-[15px] fill-[#ffffffb0]"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M44.988281 13.984375C44.726563 13.992188 44.476563 14.101563 44.292969 14.292969L25 33.585938L5.707031 14.292969C5.519531 14.097656 5.261719 13.992188 4.992188 13.988281C4.582031 13.992188 4.21875 14.238281 4.0625 14.613281C3.910156 14.992188 4 15.421875 4.292969 15.707031L24.292969 35.707031C24.683594 36.097656 25.316406 36.097656 25.707031 35.707031L45.707031 15.707031C46.003906 15.421875 46.09375 14.980469 45.9375 14.601563C45.777344 14.222656 45.402344 13.976563 44.988281 13.984375Z"
                  />
                </svg>
              </div>
              <div
                class="duration-700 bg-[#3f3f3f] h-0 overflow-hidden"
                :class="{ dropit: vpersonalinfo }"
              >
                <div class="px-6 py-4 mt-2">
                  <h2 class="text-[#a8a8a8] text-sm">Name</h2>
                  <div class="flex items-center justify-between">
                    <h1 class="text-[#ffffff] text-sm my-2">
                      {{ loggeduser.names }}
                    </h1>
                    <div
                      class="
                        w-[30px]
                        h-[30px]
                        rounded-lg
                        bg-[#4eac6d3a]
                        cursor-pointer
                        relative
                      "
                    >
                      <svg
                        class="
                          absolute
                          fill-[#58c07b]
                          w-[60%]
                          h-[60%]
                          left-1/2
                          top-1/2
                          -translate-x-1/2 -translate-y-1/2
                        "
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M19.171875 2C18.448125 2 17.724375 2.275625 17.171875 2.828125L16 4L20 8L21.171875 6.828125C22.275875 5.724125 22.275875 3.933125 21.171875 2.828125C20.619375 2.275625 19.895625 2 19.171875 2 z M 14.5 5.5L3 17L3 21L7 21L18.5 9.5L14.5 5.5 z"
                        />
                      </svg>
                    </div>
                  </div>
                  <h2 class="text-[#a8a8a8] text-sm">Userame</h2>
                  <h1 class="text-[#ffffff] text-sm my-2">
                    @{{ loggeduser.username }}
                  </h1>
                  <h2 class="text-[#a8a8a8] text-sm">Email</h2>
                  <h1 class="text-[#ffffff] text-sm my-2">
                    {{ loggeduser.email }}
                  </h1>
                  <h2 class="text-[#a8a8a8] text-sm">Age</h2>
                  <h1 class="text-[#ffffff] text-sm my-2">
                    {{ loggeduser.birthdate }}
                  </h1>
                  <h2 class="text-[#a8a8a8] text-sm">Location</h2>
                  <h1 class="text-[#ffffff] text-sm my-2">
                    {{ loggeduser.location }}
                  </h1>
                  <h2 class="text-[#a8a8a8] text-sm">Friends</h2>
                  <h1 class="text-[#ffffff] text-sm my-2">0</h1>
                  <h2 class="text-[#a8a8a8] text-sm">Joined On</h2>
                  <h1 class="text-[#ffffff] text-sm my-2">
                    {{ loggeduser.joinedat }}
                  </h1>
                </div>
              </div>
            </div>
            <div class="w-full border-t border-[#474747]">
              <div
                class="
                  flex
                  items-center
                  justify-between
                  px-4
                  py-2
                  bg-[#2b2b2b]
                  cursor-pointer
                "
                @click="paccordion('priv')"
              >
                <div class="flex items-center">
                  <div class="relative w-[30px] h-[30px] cursor-pointer mr-4">
                    <svg
                      class="
                        absolute
                        fill-[#ffffffb0]
                        h-[80%]
                        w-[80%]
                        left-1/2
                        top-1/2
                        -translate-x-1/2 -translate-y-1/2
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 50 50"
                    >
                      <path
                        d="M25 4C18.9375 4 14 8.9375 14 15L14 20.84375C11.527344 23.519531 10 27.078125 10 31C10 39.269531 16.730469 46 25 46C33.269531 46 40 39.269531 40 31C40 27.078125 38.472656 23.519531 36 20.84375L36 15C36 8.9375 31.0625 4 25 4 Z M 25 6C29.984375 6 34 10.015625 34 15L34 19.03125C31.488281 17.136719 28.378906 16 25 16C21.621094 16 18.511719 17.136719 16 19.03125L16 15C16 10.015625 20.015625 6 25 6 Z M 25 28C26.65625 28 28 29.34375 28 31C28 32.304688 27.164063 33.398438 26 33.8125L26 36C26 36.550781 25.550781 37 25 37C24.449219 37 24 36.550781 24 36L24 33.8125C22.835938 33.398438 22 32.304688 22 31C22 29.34375 23.34375 28 25 28Z"
                      />
                    </svg>
                  </div>
                  <h3 class="text-sm text-[#ffffffb0]">Privacy</h3>
                </div>
                <svg
                  class="w-[15px] h-[15px] fill-[#ffffffb0]"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M44.988281 13.984375C44.726563 13.992188 44.476563 14.101563 44.292969 14.292969L25 33.585938L5.707031 14.292969C5.519531 14.097656 5.261719 13.992188 4.992188 13.988281C4.582031 13.992188 4.21875 14.238281 4.0625 14.613281C3.910156 14.992188 4 15.421875 4.292969 15.707031L24.292969 35.707031C24.683594 36.097656 25.316406 36.097656 25.707031 35.707031L45.707031 15.707031C46.003906 15.421875 46.09375 14.980469 45.9375 14.601563C45.777344 14.222656 45.402344 13.976563 44.988281 13.984375Z"
                  />
                </svg>
              </div>
              <div
                class="duration-700 bg-[#3f3f3f] h-0 overflow-hidden"
                :class="{ dropit: vprivacy }"
              >
                <div class="px-4 py-2 mt-2">
                  <div class="flex items-center justify-between">
                    <h1 class="text-[#ffffff] text-sm my-2">Online status</h1>
                    <input
                      v-if="(loggeduser.activitystatus = true)"
                      type="checkbox"
                      class="accent-[#4eac6d]"
                      checked
                    />
                    <input v-else type="checkbox" class="accent-[#4eac6d]" />
                  </div>
                  <div class="flex items-center justify-between">
                    <h1 class="text-[#ffffff] text-sm my-2">Last seen</h1>
                    <input type="checkbox" class="accent-[#4eac6d]" />
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full border-t border-[#474747]">
              <div
                class="flex items-center justify-between px-4 py-2 cursor-pointer "
                @click="paccordion('freq')"
              >
                <div class="flex items-center">
                  <div class="relative w-[30px] h-[30px] cursor-pointer mr-4">
                    <svg
                      class="
                        absolute
                        fill-[#ffffffb0]
                        h-[80%]
                        w-[80%]
                        left-1/2
                        top-1/2
                        -translate-x-1/2 -translate-y-1/2
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 50 50"
                    >
                      <path
                        d="M19.9375 12.96875C19.414063 12.988281 18.921875 13.214844 18.5625 13.59375L8.6875 23.59375L7.3125 25L8.6875 26.40625L18.5625 36.40625C19.339844 37.199219 20.613281 37.214844 21.40625 36.4375C22.199219 35.660156 22.214844 34.386719 21.4375 33.59375L14.90625 27L40 27C40.722656 27.011719 41.390625 26.632813 41.753906 26.007813C42.121094 25.386719 42.121094 24.613281 41.753906 23.992188C41.390625 23.367188 40.722656 22.988281 40 23L14.90625 23L21.4375 16.40625C22.039063 15.824219 22.21875 14.933594 21.882813 14.164063C21.546875 13.398438 20.773438 12.921875 19.9375 12.96875Z"
                      />
                    </svg>
                  </div>
                  <h3 class="text-sm text-[#ffffffb0]">Friend Requests</h3>
                </div>
                <svg
                  class="w-[15px] h-[15px] fill-[#ffffffb0]"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M44.988281 13.984375C44.726563 13.992188 44.476563 14.101563 44.292969 14.292969L25 33.585938L5.707031 14.292969C5.519531 14.097656 5.261719 13.992188 4.992188 13.988281C4.582031 13.992188 4.21875 14.238281 4.0625 14.613281C3.910156 14.992188 4 15.421875 4.292969 15.707031L24.292969 35.707031C24.683594 36.097656 25.316406 36.097656 25.707031 35.707031L45.707031 15.707031C46.003906 15.421875 46.09375 14.980469 45.9375 14.601563C45.777344 14.222656 45.402344 13.976563 44.988281 13.984375Z"
                  />
                </svg>
              </div>
              <div
                class="bg-[#3f3f3f] h-0 overflow-hidden"
                :class="{ dropit: vfreq }"
              >
                <div class="px-4 py-2 mt-2">
                  <div
                    class="flex items-center justify-between mt-1"
                    v-for="user in receivedreq"
                    :key="user.id"
                  >
                    <div class="flex items-center">
                      <div
                        class="
                          w-[35px]
                          h-[35px]
                          rounded-full
                          overflow-hidden
                          mr-4
                          relative
                          bg-[#4b4a4a]
                        "
                      >
                        <img
                          :src="require('@/assets/profiles/' + user.profilepic)"
                          class="absolute object-cover w-full h-full"
                        />
                      </div>
                      <h1 class="ml-4 text-xs text-white">{{ user.names }}</h1>
                    </div>
                    <button
                      @click="befriends(user)"
                      class="
                        px-3
                        text-[0.8rem]
                        py-1
                        rounded-md
                        bg-[#4eac6d]
                        text-white
                      "
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full border-t border-[#474747]">
              <div
                class="flex items-center justify-between px-4 py-2 cursor-pointer "
                @click="paccordion('sreq')"
              >
                <div class="flex items-center">
                  <div class="relative w-[30px] h-[30px] cursor-pointer mr-4">
                    <svg
                      class="
                        absolute
                        fill-[#ffffffb0]
                        h-[80%]
                        w-[80%]
                        left-1/2
                        top-1/2
                        -translate-x-1/2 -translate-y-1/2
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 50 50"
                    >
                      <path
                        d="M29.84375 13.09375C29.066406 13.167969 28.402344 13.691406 28.148438 14.429688C27.890625 15.171875 28.089844 15.992188 28.65625 16.53125L35.125 23L10 23C9.9375 22.996094 9.875 22.996094 9.8125 23C8.707031 23.050781 7.855469 23.988281 7.90625 25.09375C7.957031 26.199219 8.894531 27.050781 10 27L35.125 27L28.625 33.46875C27.839844 34.253906 27.839844 35.527344 28.625 36.3125C29.410156 37.097656 30.683594 37.097656 31.46875 36.3125L41.34375 26.40625L42.78125 25L41.34375 23.59375L31.46875 13.6875C31.046875 13.253906 30.449219 13.035156 29.84375 13.09375Z"
                      />
                    </svg>
                  </div>
                  <h3 class="text-sm text-[#ffffffb0]">Sent Requests</h3>
                </div>
                <svg
                  class="w-[15px] h-[15px] fill-[#ffffffb0]"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M44.988281 13.984375C44.726563 13.992188 44.476563 14.101563 44.292969 14.292969L25 33.585938L5.707031 14.292969C5.519531 14.097656 5.261719 13.992188 4.992188 13.988281C4.582031 13.992188 4.21875 14.238281 4.0625 14.613281C3.910156 14.992188 4 15.421875 4.292969 15.707031L24.292969 35.707031C24.683594 36.097656 25.316406 36.097656 25.707031 35.707031L45.707031 15.707031C46.003906 15.421875 46.09375 14.980469 45.9375 14.601563C45.777344 14.222656 45.402344 13.976563 44.988281 13.984375Z"
                  />
                </svg>
              </div>
              <div
                class="bg-[#3f3f3f] h-0 overflow-hidden"
                :class="{ dropit: vsreq }"
              >
                <div class="px-4 py-2 mt-2">
                  <div
                    v-if="!sentreq || sentreq.length < 1"
                    class="flex items-center justify-between"
                  >
                    <h1 class="w-full text-xs text-center text-white">
                      No pending requests...
                    </h1>
                  </div>
                  <div
                    v-else
                    class="flex items-center justify-between mt-1"
                    v-for="user in sentreqes"
                    :key="user.id"
                  >
                    <div class="flex items-center">
                      <div
                        class="
                          w-[35px]
                          h-[35px]
                          rounded-full
                          overflow-hidden
                          mr-4
                          relative
                          bg-[#4b4a4a]
                        "
                      >
                        <img
                          :src="require('@/assets/profiles/' + user.profilepic)"
                          class="absolute object-cover w-full h-full"
                        />
                      </div>
                      <h1 class="ml-4 text-xs text-white">{{ user.names }}</h1>
                    </div>
                    <button
                      type="submit"
                      class="
                        px-3
                        text-[0.8rem]
                        py-1
                        rounded-md
                        bg-[#4eac6d]
                        text-white
                      "
                    >
                      Pending..
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full border-t border-[#474747]">
              <div
                class="
                  ]
                  flex
                  justify-between
                  items-center
                  px-4
                  py-2
                  cursor-pointer
                "
                @click="paccordion('not')"
              >
                <div class="flex items-center">
                  <div class="relative w-[30px] h-[30px] cursor-pointer mr-4">
                    <svg
                      class="
                        absolute
                        fill-[#ffffffb0]
                        h-[60%]
                        w-[60%]
                        left-1/2
                        top-1/2
                        -translate-x-1/2 -translate-y-1/2
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 0C10.894531 0 10 0.894531 10 2C10 2.042969 9.996094 2.082031 10 2.125C7.675781 2.429688 6 3.421875 6 6.03125C6 15.945313 1 14.035156 1 20C1 20 5.007813 21 12 21C18.992188 21 23 20 23 20C23 14.070313 18 16.003906 18 6.03125C18 3.398438 16.34375 2.421875 14 2.125C14.003906 2.082031 14 2.042969 14 2C14 0.894531 13.105469 0 12 0 Z M 9.15625 21.9375C9.550781 23.128906 10.675781 24 12 24C13.324219 24 14.449219 23.128906 14.84375 21.9375C13.960938 21.972656 13.007813 22 12 22C10.988281 22 10.042969 21.972656 9.15625 21.9375Z"
                      />
                    </svg>
                  </div>
                  <h3 class="text-sm text-[#ffffffb0]">Notifications</h3>
                </div>
                <svg
                  class="w-[15px] h-[15px] fill-[#ffffffb0]"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M44.988281 13.984375C44.726563 13.992188 44.476563 14.101563 44.292969 14.292969L25 33.585938L5.707031 14.292969C5.519531 14.097656 5.261719 13.992188 4.992188 13.988281C4.582031 13.992188 4.21875 14.238281 4.0625 14.613281C3.910156 14.992188 4 15.421875 4.292969 15.707031L24.292969 35.707031C24.683594 36.097656 25.316406 36.097656 25.707031 35.707031L45.707031 15.707031C46.003906 15.421875 46.09375 14.980469 45.9375 14.601563C45.777344 14.222656 45.402344 13.976563 44.988281 13.984375Z"
                  />
                </svg>
              </div>
              <div
                class="bg-[#3f3f3f] h-0 overflow-hidden"
                :class="{ dropit: vnotif }"
              >
                <div class="px-4 py-2 mt-2">
                  <div class="mt-1 rounded-md bg-[#222222] py-2 px-3">
                    <h2 class="text-xs text-white">
                      Shed accepted your friend request.
                    </h2>
                  </div>
                  <div class="mt-1 rounded-md bg-[#222222] py-2 px-3">
                    <h2 class="text-xs text-white">
                      U joined ChatApp at 12 Dec 2022.
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sticky top-0 z-[2] bg-[#2b2b2b] p-3">
          <div class="flex items-center mb-7">
            <div class="w-5 mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 30 30"
                fill="#FFFFFF"
              >
                <path
                  d="M15 3C13.307 3 11.817109 3.8458125 10.912109 5.1328125C9.3621094 4.8628125 7.712625 5.318625 6.515625 6.515625C5.318625 7.712625 4.8628125 9.3631094 5.1328125 10.912109C3.8458125 11.817109 3 13.307 3 15C3 16.693 3.8458125 18.182891 5.1328125 19.087891C4.8628125 20.637891 5.318625 22.287375 6.515625 23.484375C7.712625 24.681375 9.3631094 25.137187 10.912109 24.867188C11.817109 26.154187 13.307 27 15 27C16.693 27 18.182891 26.154188 19.087891 24.867188C20.637891 25.137187 22.287375 24.681375 23.484375 23.484375C24.681375 22.287375 25.137187 20.636891 24.867188 19.087891C26.154187 18.182891 27 16.693 27 15C27 13.307 26.154188 11.817109 24.867188 10.912109C25.137187 9.3621094 24.681375 7.712625 23.484375 6.515625C22.287375 5.318625 20.636891 4.8628125 19.087891 5.1328125C18.182891 3.8458125 16.693 3 15 3 z M 21 10C21.25575 10 21.511531 10.097469 21.707031 10.292969C22.098031 10.683969 22.098031 11.316031 21.707031 11.707031L14.146484 19.267578C13.958484 19.455578 13.704453 19.560547 13.439453 19.560547C13.174453 19.560547 12.919422 19.455578 12.732422 19.267578L9.2792969 15.814453C8.8882969 15.423453 8.8882969 14.791391 9.2792969 14.400391C9.6702969 14.009391 10.302359 14.009391 10.693359 14.400391L13.439453 17.146484L20.292969 10.292969C20.488469 10.097469 20.74425 10 21 10 z"
                  fill="#FFFFFF"
                />
              </svg>
            </div>
            <h1 class="tracking-[0.15rem] text-white text-sm">ChatApp</h1>
          </div>
          <div class="p-3">
            <div class="flex items-center justify-between">
              <h2 class="text-white">Chats</h2>
              <div class="relative flex items-center">
                <div
                  @click="modals('alluser')"
                  class="
                    w-[30px]
                    h-[30px]
                    relative
                    rounded-md
                    duration-500
                    cursor-pointer
                    hover:bg-[#424242]
                    mr-2
                  "
                >
                  <svg
                    class="
                      fill-[#ffffff]
                      absolute
                      w-[70%]
                      h-[70%]
                      left-1/2
                      top-1/2
                      -translate-y-1/2 -translate-x-1/2
                      object-cover
                    "
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512.000000 512.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      stroke="none"
                    >
                      <path
                        d="M2285 4675 c-536 -71 -1019 -339 -1377 -765 -147 -175 -295 -447 -372 -681 -75 -229 -106 -422 -106 -669 0 -247 31 -440 106 -669 151 -461 457 -854 879 -1131 178 -116 454 -231 675 -280 175 -39 308 -50 612 -50 l288 0 0 209 0 208 -307 6 c-315 6 -385 14 -550 56 -319 82 -636 275 -846 515 -576 659 -577 1612 -2 2269 133 152 319 295 513 392 619 311 1359 215 1891 -246 212 -183 394 -458 486 -732 73 -219 95 -389 95 -749 l0 -228 210 0 210 0 0 285 c0 311 -8 420 -46 595 -66 308 -198 591 -397 855 -73 96 -265 290 -363 367 -311 245 -700 405 -1086 447 -128 14 -388 12 -513 -4z"
                      />
                      <path
                        d="M1490 2560 l0 -210 133 0 c146 0 188 12 239 66 48 51 58 92 58 229 l0 125 -215 0 -215 0 0 -210z"
                      />
                      <path
                        d="M2350 2559 l0 -210 143 3 c134 3 146 5 180 28 21 14 50 43 65 64 26 38 27 45 30 183 l3 143 -210 0 -211 0 0 -211z"
                      />
                      <path
                        d="M3200 2559 l0 -210 144 3 c142 3 145 3 188 33 24 17 54 51 68 75 22 41 25 58 28 178 l4 132 -216 0 -216 0 0 -211z"
                      />
                      <path
                        d="M4057 1703 c-4 -3 -7 -147 -7 -320 l0 -313 -317 -2 -318 -3 -3 -212 -2 -213 320 0 320 0 0 -320 0 -320 215 0 215 0 0 320 0 320 320 0 320 0 0 215 0 215 -320 0 -320 0 0 320 0 320 -208 0 c-115 0 -212 -3 -215 -7z"
                      />
                    </g>
                  </svg>
                </div>
                <div
                  class="
                    w-[30px]
                    h-[30px]
                    relative
                    rounded-md
                    duration-500
                    cursor-pointer
                    hover:bg-[#424242]
                  "
                >
                  <svg
                    class="
                      fill-[#ffffff]
                      absolute
                      w-[70%]
                      h-[70%]
                      left-1/2
                      top-1/2
                      -translate-y-1/2 -translate-x-1/2
                      object-cover
                    "
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    preserveAspectRatio="xMidYMid meet"
                    version="1.1"
                    x="0px"
                    y="0px"
                    enable-background="new 0 0 24 24"
                    xml:space="preserve"
                  >
                    <path
                      d="M10,18.1h4v-2h-4V18.1z M3,6.1v2h18v-2H3z M6,13.1h12v-2H6V13.1z"
                    ></path>
                  </svg>
                </div>
                <div
                  :class="{ popup: allu }"
                  class="
                    absolute
                    opacity-0
                    duration-500
                    translate-y-5
                    pointer-events-none
                    w-[250px]
                    h-[500px]
                    top-full
                    rounded-md
                    shadow-lg
                    right-0
                    bg-[#424242]
                    py-4
                    px-5
                  "
                >
                  <h2 class="mb-4 text-white">New Chat</h2>
                  <input
                    type="text"
                    placeholder="Search....."
                    v-model="usersearch"
                    class="
                      mb-3
                      w-full
                      border-none
                      outline-none
                      bg-[#333]
                      p-[.5rem_1rem]
                      text-sm
                      rounded-md
                      text-[#8f9198]
                      placeholder:text-[#7d7e83]
                    "
                  />
                  <div class="w-full h-full">
                    <TransitionGroup name="semess">
                      <div v-if="!friends || friends.length < 0">
                        <p class="text-xs text-[#8f9198] w-full text-center">
                          No friends yet!
                        </p>
                      </div>
                      <div
                        v-else
                        v-for="user in friends"
                        :key="user.id"
                        @click="conservation(user)"
                        class="
                          flex
                          justify-between
                          hover:bg-[#2e2e2e]
                          duration-200
                          mb-2
                          p-2
                          rounded-md
                          cursor-pointer
                        "
                      >
                        <div class="flex items-center">
                          <div
                            class="
                              w-[40px]
                              h-[40px]
                              rounded-full
                              overflow-hidden
                              mr-4
                              relative
                              bg-[#4b4a4a]
                            "
                          >
                            <img
                              :src="
                                require('@/assets/profiles/' + user.profilepic)
                              "
                              class="absolute object-cover w-full h-full"
                            />
                          </div>
                          <div>
                            <h2 class="mb-1 text-sm text-white">
                              {{ user.names }}
                            </h2>
                            <div class="">
                              <p
                                class="
                                  text-xs text-[#8f9198]
                                  truncate
                                  w-[150px]
                                "
                                :alt="user.status"
                              >
                                {{ user.status }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TransitionGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <input
              type="text"
              placeholder="Search....."
              v-model="searchchat"
              class="
                w-full
                border-none
                outline-none
                bg-[#333]
                p-[.5rem_1rem]
                text-sm
                rounded-md
                text-[#8f9198]
                placeholder:text-[#7d7e83]
              "
            />
          </div>
        </div>
        <div class="px-2">
          <TransitionGroup name="semess">
            <div
              v-if="!recentcons || recentcons.length < 1"
              class="p-2 mb-2 duration-200"
            >
              <div class="text-center text-[#bbbaba] w-full">No chats yet!</div>
            </div>
            <div
              v-else
              v-for="user in recentcons"
              :key="user.id"
              @click="conservation(user)"
              class="
                flex
                justify-between
                hover:bg-[#424242]
                duration-200
                mb-2
                p-2
                rounded-md
                cursor-pointer
              "
            >
              <div class="flex items-center">
                <div
                  class="
                    w-[50px]
                    h-[50px]
                    rounded-full
                    overflow-hidden
                    mr-4
                    relative
                    bg-[#4b4a4a]
                  "
                >
                  <img
                    :src="require('@/assets/profiles/' + user.profilepic)"
                    class="absolute object-cover w-full h-full"
                  />
                </div>
                <div>
                  <h2 class="mb-1 text-sm font-semibold text-white">
                    {{ user.names }}
                  </h2>
                  <div class="flex items-center">
                    <div class="w-5 mr-2 fill-[#2323232]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                        fill="#FFFFFF"
                      >
                        <path
                          d="M15.980469 6.9902344 A 1.0001 1.0001 0 0 0 15.292969 7.2929688L11.455078 11.130859 A 1.0001 1.0001 0 1 0 12.869141 12.544922L16.707031 8.7070312 A 1.0001 1.0001 0 0 0 15.980469 6.9902344 z M 21.980469 6.9902344 A 1.0001 1.0001 0 0 0 21.292969 7.2929688L12 16.585938L8.7070312 13.292969 A 1.0001 1.0001 0 1 0 7.2929688 14.707031L11.292969 18.707031 A 1.0001 1.0001 0 0 0 12.707031 18.707031L22.707031 8.7070312 A 1.0001 1.0001 0 0 0 21.980469 6.9902344 z M 1.9902344 12.990234 A 1.0001 1.0001 0 0 0 1.2929688 14.707031L4.5449219 17.960938 A 1.0012744 1.0012744 0 1 0 5.9609375 16.544922L2.7070312 13.292969 A 1.0001 1.0001 0 0 0 1.9902344 12.990234 z"
                          fill="#FFFFFF"
                        />
                      </svg>
                    </div>
                    <p class="text-[0.85rem] text-[#8f9198] w-[180px] truncate">{{ user[0].txtmessage }}</p>
                  </div>
                </div>
              </div>
              <div class="text-xs text-[#bbbaba]">
                {{ timeFormat(splitTime(user[0].senttime)) }}
              </div>
            </div>
          </TransitionGroup>
        </div>
      </div>
    </div>
    <div
      class="
        w-[70%]
        bg-[url(@/assets/cpattern.png)]
        relative
        h-screen
        overflow-hidden
      "
    >
      <div
        v-if="stranger"
        class="
          absolute
          z-[3]
          w-[400px]
          h-full
          bg-[#2b2b2b]
          overflow-y-scroll
          chats
          shadow-[-10px_0px_30px_rbga(0,0,0,0.1)]
          top-0
          right-0
          pointer-events-none
          opacity-0
          translate-x-7
          duration-500
        "
        :class="{ popupx: strangerprofile }"
      >
        <div class="w-full h-[200px] relative rounded-md">
          <div class="absolute z-[1] w-full h-full bg-[#25252552]"></div>
          <div class="absolute bottom-2 left-4 z-[1]">
            <h2 class="text-[#fff] tracking-wider capitalize font-[500]">
              {{ stranger.names }}
            </h2>
          </div>
          <div
            class="
              flex
              justify-between
              w-full
              p-3
              absolute
              top-0
              left-0
              z-[1]
              items-center
            "
          >
            <div
              class="relative w-[17px] h-[17px] cursor-pointer"
              @click="closeoprofile('stranger')"
            >
              <svg
                class="
                  absolute
                  fill-[#ffffff]
                  h-full
                  w-full
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 16 16"
              >
                <path
                  d="M2.75 2.042969L2.042969 2.75L2.398438 3.101563L7.292969 8L2.042969 13.25L2.75 13.957031L8 8.707031L12.894531 13.605469L13.25 13.957031L13.957031 13.25L13.605469 12.894531L8.707031 8L13.957031 2.75L13.25 2.042969L8 7.292969L3.101563 2.398438Z"
                />
              </svg>
            </div>
            <div class="relative w-[25px] h-[25px] cursor-pointer">
              <svg
                class="
                  absolute
                  fill-[#ffffff]
                  h-full
                  w-full
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 30 30"
              >
                <path
                  d="M15 4 A 3 3 0 0 0 12 7 A 3 3 0 0 0 15 10 A 3 3 0 0 0 18 7 A 3 3 0 0 0 15 4 z M 15 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 18 A 3 3 0 0 0 18 15 A 3 3 0 0 0 15 12 z M 15 20 A 3 3 0 0 0 12 23 A 3 3 0 0 0 15 26 A 3 3 0 0 0 18 23 A 3 3 0 0 0 15 20 z"
                />
              </svg>
            </div>
          </div>
          <img
            :src="require('@/assets/profiles/' + stranger.profilepic)"
            class="absolute object-cover w-full h-full"
            draggable="false"
          />
        </div>
        <div class="flex w-full py-1 my-2 justify-evenly">
          <div
            v-if="
              stranger.frfrom == loggeduser.id &&
              stranger.frto == stranger.id &&
              stranger.approval == 0
            "
            class="flex flex-col items-center"
            @click="addfriend(stranger, loggeduser)"
          >
            <div
              class="
                relative
                w-[30px]
                h-[30px]
                cursor-pointer
                bg-[#202020]
                rounded-md
              "
            >
              <svg
                class="
                  absolute
                  fill-[#dddddd]
                  h-[70%]
                  w-[70%]
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
              >
                <path
                  d="M9 0L9 2L15 2L15 0 Z M 11 3L11 4.0625C5.933594 4.558594 2 8.800781 2 14C2 19.535156 6.464844 24 12 24C17.535156 24 22 19.535156 22 14C22 11.082031 20.738281 8.484375 18.75 6.65625L20.09375 5.3125L18.6875 3.90625L17.15625 5.4375C15.917969 4.695313 14.511719 4.210938 13 4.0625L13 3 Z M 12 6C16.464844 6 20 9.535156 20 14C20 18.464844 16.464844 22 12 22C7.535156 22 4 18.464844 4 14C4 9.535156 7.535156 6 12 6 Z M 6.5 8.5L10.0625 13.46875C10.015625 13.636719 10 13.816406 10 14C10 15.105469 10.894531 16 12 16C13.105469 16 14 15.105469 14 14C14 12.894531 13.105469 12 12 12C11.816406 12 11.636719 12.015625 11.46875 12.0625Z"
                />
              </svg>
            </div>
            <p class="mt-2 text-[0.65rem] text-[#c9c9c9] tracking-widest">
              PENDING...
            </p>
          </div>
          <div
            v-else-if="
              stranger.frto == loggeduser.id &&
              stranger.frfrom == stranger.id &&
              stranger.approval == 0
            "
            class="flex flex-col items-center"
            @click="befriendss(stranger, loggeduser)"
          >
            <div
              class="
                relative
                w-[30px]
                h-[30px]
                cursor-pointer
                bg-[#202020]
                rounded-md
              "
            >
              <svg
                class="
                  absolute
                  fill-[#dddddd]
                  h-[70%]
                  w-[70%]
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 48 48"
              >
                <path
                  d="M42.960938 8.9804688 A 2.0002 2.0002 0 0 0 41.585938 9.5859375L17 34.171875L6.4140625 23.585938 A 2.0002 2.0002 0 1 0 3.5859375 26.414062L15.585938 38.414062 A 2.0002 2.0002 0 0 0 18.414062 38.414062L44.414062 12.414062 A 2.0002 2.0002 0 0 0 42.960938 8.9804688 z"
                />
              </svg>
            </div>
            <p class="mt-2 text-[0.65rem] text-[#c9c9c9] tracking-widest">
              ACCEPT REQUEST
            </p>
          </div>
          <div
            v-else-if="
              (stranger.frto == loggeduser.id &&
                stranger.frfrom == stranger.id &&
                allusers.approval == 1) ||
              (stranger.frto == stranger.id &&
                stranger.frfrom == loggeduser.id &&
                allusers.approval == 1)
            "
            class="flex flex-col items-center"
            @click="addfriend(stranger, loggeduser)"
          >
            <div
              class="
                relative
                w-[30px]
                h-[30px]
                cursor-pointer
                bg-[#202020]
                rounded-md
              "
            >
              <svg
                class="
                  absolute
                  fill-[#dddddd]
                  h-[70%]
                  w-[70%]
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 48 48"
              >
                <path
                  d="M42.960938 8.9804688 A 2.0002 2.0002 0 0 0 41.585938 9.5859375L17 34.171875L6.4140625 23.585938 A 2.0002 2.0002 0 1 0 3.5859375 26.414062L15.585938 38.414062 A 2.0002 2.0002 0 0 0 18.414062 38.414062L44.414062 12.414062 A 2.0002 2.0002 0 0 0 42.960938 8.9804688 z"
                />
              </svg>
            </div>
            <p class="mt-2 text-[0.65rem] text-[#c9c9c9] tracking-widest">
              FRIENDS
            </p>
          </div>
          <div
            v-else
            class="flex flex-col items-center"
            @click="addfriend(stranger, loggeduser)"
          >
            <div
              class="
                relative
                w-[30px]
                h-[30px]
                cursor-pointer
                bg-[#202020]
                rounded-md
              "
            >
              <svg
                class="
                  absolute
                  fill-[#dddddd]
                  h-[70%]
                  w-[70%]
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 50 50"
              >
                <path
                  d="M20.25 2C16.81 2 14.244937 2.9910625 12.710938 5.0390625C10.837938 7.5400625 10.520875 11.446766 11.671875 16.634766C11.231875 17.174766 10.912969 18.013516 11.042969 19.103516C11.302969 21.273516 12.131797 22.163437 12.841797 22.523438C13.171797 24.203437 14.090234 26.070469 14.990234 26.980469C14.990234 26.980469 15 29.5 14.875 30.625C14.275 32.005 12.319766 32.589766 10.009766 33.509766C6.1497656 35.049766 1.36 36.959453 1 42.939453L0.93945312 44L30.839844 44C32.389844 47.52 35.92 50 40 50C45.5 50 50 45.5 50 40C50 34.99 46.269219 30.809375 41.449219 30.109375C41.449219 30.109375 41.420156 30.099844 41.410156 30.089844C39.810156 29.379844 37.545 27.655 37.125 26.875C37 26 37.009766 23.869141 37.009766 23.869141C37.839766 23.109141 38.959609 21.550937 39.349609 19.960938C39.999609 19.610937 40.740703 18.780313 40.970703 16.820312C41.090703 15.830312 40.810156 15.060781 40.410156 14.550781C40.910156 12.330781 41.604391 8.0830781 39.900391 5.5800781C39.201391 4.5530781 38.180859 3.910625 36.880859 3.640625C36.020859 2.580625 34.409297 2 32.279297 2C30.699297 2 29.370469 2.2703125 28.230469 2.8203125C29.090469 3.3403125 29.830156 4.040625 30.410156 4.890625C32.150156 7.420625 32.500703 11.140469 31.470703 16.230469C31.930703 17.150469 32.110469 18.210078 31.980469 19.330078C31.700469 21.650078 30.840938 22.970703 29.960938 23.720703C29.540937 25.220703 28.81 26.750078 28 27.830078C28 28.560078 27.999063 29.199922 28.039062 29.919922C28.579062 30.499922 30.370938 31.200469 31.710938 31.730469C32.260937 31.940469 33.480469 32.439453 33.480469 32.439453C32.940469 32.899453 32.449531 33.43 32.019531 34C31.669531 33.86 31.330234 33.719844 30.990234 33.589844C28.680234 32.689844 26.725 31.995 26.125 30.625C26 29.5 26.009766 27.089844 26.009766 27.089844C26.909766 26.169844 27.849453 24.209766 28.189453 22.509766C28.899453 22.149766 29.730234 21.259844 29.990234 19.089844C30.120234 17.989844 29.789609 17.149375 29.349609 16.609375C29.869609 14.269375 30.849766 9.0695313 28.759766 6.0195312C28.159766 5.1495312 27.370391 4.5208594 26.400391 4.1308594C26.240391 4.0608594 25.529844 3.8505469 25.339844 3.8105469C24.409844 2.6405469 22.63 2 20.25 2 z M 40 32C44.4 32 48 35.6 48 40C48 44.4 44.4 48 40 48C35.6 48 32 44.4 32 40C32 35.6 35.6 32 40 32 z M 40 34C39.4 34 39 34.400391 39 34.900391L39 39L35 39C34.7 39 34.450391 39.100391 34.275391 39.275391C34.187891 39.362891 34.119141 39.467969 34.072266 39.589844C34.025391 39.711719 34 39.85 34 40C34 40.3 34.100391 40.549609 34.275391 40.724609C34.362891 40.812109 34.467969 40.880859 34.589844 40.927734C34.711719 40.974609 34.85 41 35 41L39 41L39 45C39 45.6 39.4 46 40 46C40.6 46 41 45.6 41 45L41 41L45 41C45.6 41 46 40.6 46 40C46 39.4 45.599609 39 45.099609 39L41 39L41 35C41 34.4 40.6 34 40 34 z"
                />
              </svg>
            </div>
            <p class="mt-2 text-[0.65rem] text-[#c9c9c9] tracking-widest">
              ADD FRIEND
            </p>
          </div>
        </div>
        <div class="w-full mt-2">
          <div class="w-full border-t border-[#414141]">
            <div class="flex items-center justify-between px-4 py-3">
              <h3 class="text-xs text-[#ffffffb0]">STATUS:</h3>
            </div>
            <div class="bg-[#3f3f3f] px-3 py-1">
              <h1 class="text-[#ffffff] text-sm my-2">{{ stranger.status }}</h1>
            </div>
          </div>
          <div class="w-full border-t border-[#414141]">
            <div class="flex items-center justify-between px-4 py-3">
              <h3 class="text-xs text-[#ffffffb0]">INFO:</h3>
            </div>
            <div class="bg-[#3f3f3f] px-4 py-4">
              <h2 class="text-[#a8a8a8] text-sm">Name</h2>
              <h1 class="text-[#ffffff] text-sm my-2">{{ stranger.name }}</h1>
              <h2 class="text-[#a8a8a8] text-sm">Username</h2>
              <h1 class="text-[#ffffff] text-sm my-2">
                @{{ stranger.username }}
              </h1>
              <h2 class="text-[#a8a8a8] text-sm">Email</h2>
              <h1 class="text-[#ffffff] text-sm my-2">{{ stranger.email }}</h1>
              <h2 class="text-[#a8a8a8] text-sm">Location</h2>
              <h1 class="text-[#ffffff] text-sm my-2">
                {{ stranger.location }}
              </h1>
              <h2 class="text-[#a8a8a8] text-sm">Joined at</h2>
              <h1 class="text-[#ffffff] text-sm my-2">
                {{ stranger.joinedat }}
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="chat"
        class="
          absolute
          z-[3]
          w-[400px]
          h-full
          bg-[#2b2b2b]
          overflow-y-scroll
          chats
          shadow-[-10px_0px_30px_rbga(0,0,0,0.1)]
          top-0
          right-0
          pointer-events-none
          opacity-0
          translate-x-7
          duration-500
        "
        :class="{ popupx: othersprofile }"
      >
        <div class="w-full h-[200px] relative rounded-md">
          <div class="absolute z-[1] w-full h-full bg-[#25252552]"></div>
          <div class="absolute bottom-2 left-4 z-[1]">
            <h2 class="text-[#fff] tracking-wider capitalize font-[500]">
              {{ chat.username }}
            </h2>
            <p class="text-sm text-[#d3d2d2]">Online</p>
          </div>
          <div
            class="
              flex
              justify-between
              w-full
              p-3
              absolute
              top-0
              left-0
              z-[1]
              items-center
            "
          >
            <div
              class="relative w-[17px] h-[17px] cursor-pointer"
              @click="closeoprofile('friend')"
            >
              <svg
                class="
                  absolute
                  fill-[#ffffff]
                  h-full
                  w-full
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 16 16"
              >
                <path
                  d="M2.75 2.042969L2.042969 2.75L2.398438 3.101563L7.292969 8L2.042969 13.25L2.75 13.957031L8 8.707031L12.894531 13.605469L13.25 13.957031L13.957031 13.25L13.605469 12.894531L8.707031 8L13.957031 2.75L13.25 2.042969L8 7.292969L3.101563 2.398438Z"
                />
              </svg>
            </div>
            <div class="relative w-[25px] h-[25px] cursor-pointer">
              <svg
                class="
                  absolute
                  fill-[#ffffff]
                  h-full
                  w-full
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 30 30"
              >
                <path
                  d="M15 4 A 3 3 0 0 0 12 7 A 3 3 0 0 0 15 10 A 3 3 0 0 0 18 7 A 3 3 0 0 0 15 4 z M 15 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 18 A 3 3 0 0 0 18 15 A 3 3 0 0 0 15 12 z M 15 20 A 3 3 0 0 0 12 23 A 3 3 0 0 0 15 26 A 3 3 0 0 0 18 23 A 3 3 0 0 0 15 20 z"
                />
              </svg>
            </div>
          </div>
          <img
            :src="require('@/assets/profiles/' + chat.profilepic)"
            class="absolute object-cover w-full h-full"
            draggable="false"
          />
        </div>
        <div class="flex w-full py-1 my-2 justify-evenly">
          <div class="flex flex-col items-center">
            <div
              class="
                relative
                w-[30px]
                h-[30px]
                cursor-pointer
                bg-[#202020]
                rounded-md
              "
            >
              <svg
                class="
                  absolute
                  fill-[#dddddd]
                  h-[70%]
                  w-[70%]
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 50 50"
              >
                <path
                  d="M11.839844 2.988281C11.070313 2.925781 10.214844 3.148438 9.425781 3.703125C8.730469 4.1875 7.230469 5.378906 5.828125 6.726563C5.128906 7.398438 4.460938 8.097656 3.945313 8.785156C3.425781 9.472656 2.972656 10.101563 3 11.015625C3.027344 11.835938 3.109375 14.261719 4.855469 17.980469C6.601563 21.695313 9.988281 26.792969 16.59375 33.402344C23.203125 40.011719 28.300781 43.398438 32.015625 45.144531C35.730469 46.890625 38.160156 46.972656 38.980469 47C39.890625 47.027344 40.519531 46.574219 41.207031 46.054688C41.894531 45.535156 42.59375 44.871094 43.265625 44.171875C44.609375 42.769531 45.800781 41.269531 46.285156 40.574219C47.390625 39 47.207031 37.140625 45.976563 36.277344C45.203125 35.734375 38.089844 31 37.019531 30.34375C35.933594 29.679688 34.683594 29.980469 33.566406 30.570313C32.6875 31.035156 30.308594 32.398438 29.628906 32.789063C29.117188 32.464844 27.175781 31.171875 23 26.996094C18.820313 22.820313 17.53125 20.878906 17.207031 20.367188C17.597656 19.6875 18.957031 17.320313 19.425781 16.425781C20.011719 15.3125 20.339844 14.050781 19.640625 12.957031C19.347656 12.492188 18.015625 10.464844 16.671875 8.429688C15.324219 6.394531 14.046875 4.464844 13.714844 4.003906L13.714844 4C13.28125 3.402344 12.605469 3.050781 11.839844 2.988281 Z M 11.65625 5.03125C11.929688 5.066406 12.09375 5.175781 12.09375 5.175781C12.253906 5.398438 13.65625 7.5 15 9.53125C16.34375 11.566406 17.714844 13.652344 17.953125 14.03125C17.992188 14.089844 18.046875 14.753906 17.65625 15.492188L17.65625 15.496094C17.214844 16.335938 15.15625 19.933594 15.15625 19.933594L14.871094 20.4375L15.164063 20.9375C15.164063 20.9375 16.699219 23.527344 21.582031 28.410156C26.46875 33.292969 29.058594 34.832031 29.058594 34.832031L29.558594 35.125L30.0625 34.839844C30.0625 34.839844 33.652344 32.785156 34.5 32.339844C35.238281 31.953125 35.902344 32.003906 35.980469 32.050781C36.671875 32.476563 44.355469 37.582031 44.828125 37.914063C44.84375 37.925781 45.261719 38.558594 44.652344 39.425781L44.648438 39.425781C44.28125 39.953125 43.078125 41.480469 41.824219 42.785156C41.195313 43.4375 40.550781 44.046875 40.003906 44.457031C39.457031 44.867188 38.96875 44.996094 39.046875 45C38.195313 44.972656 36.316406 44.953125 32.867188 43.332031C29.417969 41.714844 24.496094 38.476563 18.007813 31.984375C11.523438 25.5 8.285156 20.578125 6.664063 17.125C5.046875 13.675781 5.027344 11.796875 5 10.949219C5.003906 11.027344 5.132813 10.535156 5.542969 9.988281C5.953125 9.441406 6.558594 8.792969 7.210938 8.164063C8.519531 6.910156 10.042969 5.707031 10.570313 5.339844L10.570313 5.34375C11.003906 5.039063 11.382813 5 11.65625 5.03125Z"
                />
              </svg>
            </div>
            <p class="mt-2 text-[0.65rem] text-[#c9c9c9] tracking-widest">
              CALL
            </p>
          </div>
          <div class="flex flex-col items-center">
            <div
              class="
                relative
                w-[30px]
                h-[30px]
                cursor-pointer
                bg-[#202020]
                rounded-md
              "
            >
              <svg
                class="
                  absolute
                  fill-[#dddddd]
                  h-[70%]
                  w-[70%]
                  left-1/2
                  top-1/2
                  -translate-x-1/2 -translate-y-1/2
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 50 50"
              >
                <path
                  d="M20.90625 2C17.40625 2.101563 14.914063 3.085938 13.3125 5.1875C11.414063 7.6875 11.085938 11.414063 12.1875 16.3125C11.789063 16.8125 11.492188 17.6875 11.59375 18.6875C11.894531 20.789063 12.707031 21.699219 13.40625 22C13.707031 23.699219 14.699219 25.488281 15 26.1875L15 29.8125C14.398438 31.113281 12.605469 31.886719 10.40625 32.6875C6.804688 34.1875 2.300781 36.007813 2 41.90625L1.90625 43L25.40625 43C24.507813 41.199219 24 39.199219 24 37C24 33.800781 25.101563 30.988281 27 28.6875L27 26.1875C27.300781 25.585938 28.292969 23.699219 28.59375 22C29.292969 21.601563 30.105469 20.789063 30.40625 18.6875C30.507813 17.6875 30.210938 16.8125 29.8125 16.3125C30.414063 14.414063 31.5 9.386719 29.5 6.1875C28.699219 4.886719 27.511719 4.085938 25.8125 3.6875C24.914063 2.585938 23.207031 2 20.90625 2 Z M 37 26C30.953125 26 26 30.953125 26 37C26 43.046875 30.953125 48 37 48C43.046875 48 48 43.046875 48 37C48 30.953125 43.046875 26 37 26 Z M 37 28C39.121094 28 41.082031 28.730469 42.625 29.96875L29.96875 42.625C28.730469 41.082031 28 39.121094 28 37C28 32.046875 32.046875 28 37 28 Z M 44.03125 31.375C45.269531 32.917969 46 34.878906 46 37C46 41.953125 41.953125 46 37 46C34.878906 46 32.917969 45.269531 31.375 44.03125Z"
                />
              </svg>
            </div>
            <p class="mt-2 text-[0.65rem] text-[#c9c9c9] tracking-widest">
              UNFRIEND
            </p>
          </div>
        </div>
        <div class="w-full mt-2">
          <div class="w-full border-t border-[#414141]">
            <div class="flex items-center justify-between px-4 py-3">
              <h3 class="text-xs text-[#ffffffb0]">STATUS:</h3>
            </div>
            <div class="bg-[#3f3f3f] px-3 py-1">
              <h1 class="text-[#ffffff] text-sm my-2">{{ chat.status }}</h1>
            </div>
          </div>
          <div class="w-full border-t border-[#414141]">
            <div class="flex items-center justify-between px-4 py-3">
              <h3 class="text-xs text-[#ffffffb0]">INFO:</h3>
            </div>
            <div class="bg-[#3f3f3f] px-4 py-4">
              <h2 class="text-[#a8a8a8] text-sm">Name</h2>
              <h1 class="text-[#ffffff] text-sm my-2">{{ chat.names }}</h1>
              <h2 class="text-[#a8a8a8] text-sm">Username</h2>
              <h1 class="text-[#ffffff] text-sm my-2">@{{ chat.username }}</h1>
              <h2 class="text-[#a8a8a8] text-sm">Email</h2>
              <h1 class="text-[#ffffff] text-sm my-2">{{ chat.email }}</h1>
              <h2 class="text-[#a8a8a8] text-sm">Location</h2>
              <h1 class="text-[#ffffff] text-sm my-2">{{ chat.location }}</h1>
              <h2 class="text-[#a8a8a8] text-sm">Joined at</h2>
              <h1 class="text-[#ffffff] text-sm my-2">{{ chat.joinedat }}</h1>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!chat"
        class="absolute flex flex-col items-center justify-center -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2"
      >
        <div class="w-[50px] py-1 h-[50px] relative mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 30 30"
            fill="#FFFFFF"
          >
            <path
              d="M15 3C13.307 3 11.817109 3.8458125 10.912109 5.1328125C9.3621094 4.8628125 7.712625 5.318625 6.515625 6.515625C5.318625 7.712625 4.8628125 9.3631094 5.1328125 10.912109C3.8458125 11.817109 3 13.307 3 15C3 16.693 3.8458125 18.182891 5.1328125 19.087891C4.8628125 20.637891 5.318625 22.287375 6.515625 23.484375C7.712625 24.681375 9.3631094 25.137187 10.912109 24.867188C11.817109 26.154187 13.307 27 15 27C16.693 27 18.182891 26.154188 19.087891 24.867188C20.637891 25.137187 22.287375 24.681375 23.484375 23.484375C24.681375 22.287375 25.137187 20.636891 24.867188 19.087891C26.154187 18.182891 27 16.693 27 15C27 13.307 26.154188 11.817109 24.867188 10.912109C25.137187 9.3621094 24.681375 7.712625 23.484375 6.515625C22.287375 5.318625 20.636891 4.8628125 19.087891 5.1328125C18.182891 3.8458125 16.693 3 15 3 z M 21 10C21.25575 10 21.511531 10.097469 21.707031 10.292969C22.098031 10.683969 22.098031 11.316031 21.707031 11.707031L14.146484 19.267578C13.958484 19.455578 13.704453 19.560547 13.439453 19.560547C13.174453 19.560547 12.919422 19.455578 12.732422 19.267578L9.2792969 15.814453C8.8882969 15.423453 8.8882969 14.791391 9.2792969 14.400391C9.6702969 14.009391 10.302359 14.009391 10.693359 14.400391L13.439453 17.146484L20.292969 10.292969C20.488469 10.097469 20.74425 10 21 10 z"
              fill="#FFFFFF"
            />
          </svg>
        </div>
        <div class="text-center">
          <h2 class="text-[1.7rem] text-[#adb5bd]">Welcome Back!</h2>
          <p class="text-[#bbbaba]">
            Send ad receive messages anytime from now
          </p>
        </div>
      </div>
      <div v-else class="relative w-full h-full">
        <div
          v-if="viewupload"
          class="
            absolute
            bg-[#2e2e2e]
            px-4
            py-6
            items-center
            shadow-[-10px_10px_30px_rgba(0,0,0,0.1)]
            w-8/12
            -translate-x-1/2 -translate-y-1/2
            rounded-md
            left-1/2
            top-1/2
          "
        >
          <div class="text-center text-white">
            <label for="upl">upload under development! 🙈🙈</label>
            <input type="file" id="upl" class="hidden" />
          </div>
        </div>
        <div class="sticky top-0 w-full bg-[#333333]">
          <div class="flex justify-between p-2 duration-500">
            <div
              class="flex items-center cursor-pointer"
              @click="vothersprofile('friend')"
            >
              <div
                class="
                  w-[50px]
                  h-[50px]
                  rounded-full
                  overflow-hidden
                  mr-4
                  relative
                "
              >
                <img
                  :src="require('@/assets/profiles/' + chat.profilepic)"
                  class="absolute object-cover w-full h-full bg-[#4b4a4a]"
                />
              </div>
              <div>
                <h2 class="mb-1 text-sm font-semibold text-white">
                  {{ chat.names }}
                </h2>
                <div class="">
                  <p class="text-sm text-[#8f9198]">Online</p>
                </div>
              </div>
            </div>
            <div class="flex items-center">
              <div class="w-[20px] relative mr-4">
                <svg
                  class="fill-white"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M11.839844 2.988281C11.070313 2.925781 10.214844 3.148438 9.425781 3.703125C8.730469 4.1875 7.230469 5.378906 5.828125 6.726563C5.128906 7.398438 4.460938 8.097656 3.945313 8.785156C3.425781 9.472656 2.972656 10.101563 3 11.015625C3.027344 11.835938 3.109375 14.261719 4.855469 17.980469C6.601563 21.695313 9.988281 26.792969 16.59375 33.402344C23.203125 40.011719 28.300781 43.398438 32.015625 45.144531C35.730469 46.890625 38.160156 46.972656 38.980469 47C39.890625 47.027344 40.519531 46.574219 41.207031 46.054688C41.894531 45.535156 42.59375 44.871094 43.265625 44.171875C44.609375 42.769531 45.800781 41.269531 46.285156 40.574219C47.390625 39 47.207031 37.140625 45.976563 36.277344C45.203125 35.734375 38.089844 31 37.019531 30.34375C35.933594 29.679688 34.683594 29.980469 33.566406 30.570313C32.6875 31.035156 30.308594 32.398438 29.628906 32.789063C29.117188 32.464844 27.175781 31.171875 23 26.996094C18.820313 22.820313 17.53125 20.878906 17.207031 20.367188C17.597656 19.6875 18.957031 17.320313 19.425781 16.425781C20.011719 15.3125 20.339844 14.050781 19.640625 12.957031C19.347656 12.492188 18.015625 10.464844 16.671875 8.429688C15.324219 6.394531 14.046875 4.464844 13.714844 4.003906L13.714844 4C13.28125 3.402344 12.605469 3.050781 11.839844 2.988281 Z M 11.65625 5.03125C11.929688 5.066406 12.09375 5.175781 12.09375 5.175781C12.253906 5.398438 13.65625 7.5 15 9.53125C16.34375 11.566406 17.714844 13.652344 17.953125 14.03125C17.992188 14.089844 18.046875 14.753906 17.65625 15.492188L17.65625 15.496094C17.214844 16.335938 15.15625 19.933594 15.15625 19.933594L14.871094 20.4375L15.164063 20.9375C15.164063 20.9375 16.699219 23.527344 21.582031 28.410156C26.46875 33.292969 29.058594 34.832031 29.058594 34.832031L29.558594 35.125L30.0625 34.839844C30.0625 34.839844 33.652344 32.785156 34.5 32.339844C35.238281 31.953125 35.902344 32.003906 35.980469 32.050781C36.671875 32.476563 44.355469 37.582031 44.828125 37.914063C44.84375 37.925781 45.261719 38.558594 44.652344 39.425781L44.648438 39.425781C44.28125 39.953125 43.078125 41.480469 41.824219 42.785156C41.195313 43.4375 40.550781 44.046875 40.003906 44.457031C39.457031 44.867188 38.96875 44.996094 39.046875 45C38.195313 44.972656 36.316406 44.953125 32.867188 43.332031C29.417969 41.714844 24.496094 38.476563 18.007813 31.984375C11.523438 25.5 8.285156 20.578125 6.664063 17.125C5.046875 13.675781 5.027344 11.796875 5 10.949219C5.003906 11.027344 5.132813 10.535156 5.542969 9.988281C5.953125 9.441406 6.558594 8.792969 7.210938 8.164063C8.519531 6.910156 10.042969 5.707031 10.570313 5.339844L10.570313 5.34375C11.003906 5.039063 11.382813 5 11.65625 5.03125Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            w-full
            h-[calc(100%-66px-50px)]
            pt-4
            px-4
            pb-30
            overflow-y-scroll
            chats
            duration-500
          "
          id="chatz"
        >
          <TransitionGroup name="semess">
            <div
              class="w-full mb-2"
              v-for="message in messages"
              :key="message.id"
            >
              <div
                v-if="message.mfrom == loggeduser.id"
                class="flex flex-col items-end w-full"
              >
                <div class="bg-[#4eac6dcb] w-fit px-4 py-2 rounded-sm relative">
                  <div class="mr-10 text-sm">{{ message.txtmessage }}</div>
                  <div
                    class="text-[10px] text-[#222222] absolute right-1 bottom-1"
                  >
                    {{ timeFormat(splitTime(message.senttime)) }}
                  </div>
                </div>
              </div>
              <div
                v-else
                class="
                  bg-[#919e96cb]
                  flex flex-col
                  items-start
                  w-fit
                  px-4
                  py-2
                  rounded-sm
                  relative
                "
              >
                <div class="mr-10 text-sm">{{ message.txtmessage }}</div>
                <div
                  class="text-[10px] text-[#222222] absolute right-1 bottom-1"
                >
                  {{ timeFormat(splitTime(message.senttime)) }}
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>
        <div class="bg-[#1f1f1f] h-[50px]">
          <div class="flex items-center justify-between h-full px-7">
            <div class="flex items-center">
              <div class="flex items-center mr-4">
                <div class="relative rounded-md w-7 p-1 hover:bg-[#424242]">
                  <svg
                    class="fill-white"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 0C5.363281 0 0 5.363281 0 12C0 18.636719 5.363281 24 12 24C18.636719 24 24 18.636719 24 12C24 5.363281 18.636719 0 12 0 Z M 12 2C17.566406 2 22 6.433594 22 12C22 17.566406 17.566406 22 12 22C6.433594 22 2 17.566406 2 12C2 6.433594 6.433594 2 12 2 Z M 8 8C6.894531 8 6 8.894531 6 10C6 11.105469 6.894531 12 8 12C9.105469 12 10 11.105469 10 10C10 8.894531 9.105469 8 8 8 Z M 16 8C14.894531 8 14 8.894531 14 10C14 11.105469 14.894531 12 16 12C17.105469 12 18 11.105469 18 10C18 8.894531 17.105469 8 16 8 Z M 7.8125 14.84375L6.1875 15.96875C7.464844 17.828125 9.582031 19 12 19C14.417969 19 16.535156 17.828125 17.8125 15.96875L16.1875 14.84375C15.265625 16.183594 13.78125 17 12 17C10.21875 17 8.734375 16.183594 7.8125 14.84375Z"
                    />
                  </svg>
                </div>
              </div>
              <div class="flex items-center">
                <div
                  @click="modals('upload')"
                  class="relative rounded-md w-7 p-1 hover:bg-[#424242]"
                >
                  <svg
                    class="fill-white"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 26 26"
                  >
                    <path
                      d="M19.71875 2.0625C19.328125 2.074219 18.9375 2.15625 18.5625 2.28125C17.0625 2.785156 15.777344 3.941406 14.5 5.21875L6.25 13.46875C5.515625 14.203125 4.953125 15.097656 4.78125 16.15625C4.609375 17.214844 4.929688 18.425781 5.84375 19.34375C6.78125 20.28125 8.035156 20.5625 9.09375 20.375C10.152344 20.1875 11.039063 19.617188 11.71875 18.9375L20.78125 9.875C21.078125 9.632813 21.214844 9.246094 21.128906 8.871094C21.042969 8.5 20.75 8.207031 20.378906 8.121094C20.003906 8.035156 19.617188 8.171875 19.375 8.46875L10.3125 17.53125C9.882813 17.960938 9.289063 18.308594 8.75 18.40625C8.210938 18.503906 7.753906 18.441406 7.25 17.9375C6.726563 17.414063 6.667969 16.972656 6.75 16.46875C6.832031 15.964844 7.148438 15.382813 7.65625 14.875L15.90625 6.625C17.113281 5.417969 18.273438 4.496094 19.1875 4.1875C20.101563 3.878906 20.757813 3.945313 21.8125 5C22.601563 5.785156 23.4375 6.496094 23.65625 7.21875C23.765625 7.578125 23.765625 7.9375 23.53125 8.53125C23.296875 9.125 22.785156 9.933594 21.8125 10.90625C17.664063 15.054688 14.480469 18.238281 12.75 19.96875C11.214844 21.503906 9.761719 22.53125 8.46875 22.8125C7.175781 23.09375 5.949219 22.792969 4.34375 21.1875C2.738281 19.582031 2.175781 18.023438 2.34375 16.40625C2.511719 14.789063 3.496094 13.035156 5.3125 11.21875C7.507813 9.023438 12.09375 4.8125 12.09375 4.8125C12.398438 4.585938 12.546875 4.203125 12.476563 3.828125C12.40625 3.453125 12.128906 3.152344 11.765625 3.050781C11.398438 2.945313 11.003906 3.0625 10.75 3.34375C10.75 3.34375 6.160156 7.5 3.875 9.78125C1.851563 11.804688 0.578125 13.976563 0.34375 16.21875C0.109375 18.460938 1.015625 20.671875 2.9375 22.59375C4.855469 24.515625 6.929688 25.203125 8.875 24.78125C10.820313 24.359375 12.503906 23.027344 14.15625 21.375C15.886719 19.644531 19.070313 16.460938 23.21875 12.3125C24.320313 11.210938 25.03125 10.230469 25.40625 9.28125C25.78125 8.332031 25.796875 7.398438 25.5625 6.625C25.097656 5.078125 23.84375 4.214844 23.21875 3.59375C22.503906 2.878906 21.710938 2.425781 20.90625 2.21875C20.503906 2.113281 20.109375 2.050781 19.71875 2.0625Z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <input
              type="text"
              v-model="message"
              @keydown.enter="sendmessage(chat)"
              placeholder="Type a message...."
              class="
                placeholder:text-[#a0a0a0]
                text-[#a5a6ac]
                px-4
                py-2
                text-sm
                w-[70%]
                outline-none
                bg-transparent
                focus:bg-[#353535]
                duration-500
                rounded-md
              "
            />
            <div
              class="flex items-center rounded-md w-7 p-1 hover:bg-[#424242]"
            >
              <TransitionGroup name="resend">
                <div class="w-[20px] relative" v-if="!message">
                  <svg
                    class="fill-white"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 48 48"
                  >
                    <path
                      d="M24 2C19.047281 2 15 6.0472805 15 11L15 26C15 30.952719 19.047281 35 24 35C28.952719 35 33 30.952719 33 26L33 11C33 6.0472805 28.952719 2 24 2 z M 10.476562 20.978516 A 1.50015 1.50015 0 0 0 9 22.5L9 26C9 33.760508 14.934038 40.16812 22.5 40.923828L22.5 45.5 A 1.50015 1.50015 0 1 0 25.5 45.5L25.5 40.923828C33.065962 40.16812 39 33.760508 39 26L39 22.5 A 1.50015 1.50015 0 1 0 36 22.5L36 26C36 32.585372 30.739679 37.894735 24.177734 37.990234 A 1.50015 1.50015 0 0 0 23.976562 37.978516 A 1.50015 1.50015 0 0 0 23.8125 37.990234C17.255134 37.889572 12 32.582085 12 26L12 22.5 A 1.50015 1.50015 0 0 0 10.476562 20.978516 z"
                    />
                  </svg>
                </div>
                <div @click="sendmessage" class="w-[20px] relative" v-else>
                  <svg
                    class="fill-white"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 128.000000 128.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
                      stroke="none"
                    >
                      <path
                        d="M80 1183 c-31 -11 -70 -58 -76 -90 -4 -23 8 -90 42 -223 l49 -190 234 -2 c210 -3 235 -5 245 -21 8 -12 8 -22 0 -35 -10 -15 -35 -17 -245 -20 l-234 -2 -49 -190 c-53 -211 -54 -239 -7 -284 61 -58 60 -58 572 154 628 260 621 257 644 288 13 18 20 43 20 72 0 65 -25 93 -120 134 -366 157 -1008 416 -1031 415 -16 0 -36 -3 -44 -6z"
                      />
                    </g>
                  </svg>
                </div>
              </TransitionGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "ChatView",
  data() {
    return {
      viewupload: false,
      chat: null,
      isActive: false,
      allu: false,
      searchchat: "",
      usersearch: "",
      maprofile: false,
      message: null,
      othersprofile: false,
      strangerprofile: false,
      chatusers: false,
      stranger: null,
      messages: [],
      recentcons: [],
      allusers: [],
      sentreq: [],
      receivedreq: [],
      friends: [],
      /// em accord..
      vpersonalinfo: false,
      vprivacy: false,
      vfreq: false,
      vsreq: false,
      vnotif: false,
    };
  },
  computed: {
    // recentchats() {
    //   return this.recentcons.filter((recent) => {
    //     return recent.name.toLowerCase().match(this.searchchat.toLowerCase());
    //   });
    // },
    // all(){
    // return this.pullusers.filter((user) =>{
    //   return user.name.toLowerCase().match(this.usersearch.toLowerCase())
    // }).sort((a, b) => {
    //   if (a.name < b.name)
    //       return -1;
    //   if (a.name > b.name)
    //     return 1;
    //     return 0;
    // });
    // },
    active() {
      return (this.loggeduser = this.$store.state.activeuser);
    },
    // pulledusers() {
    //   return (this.allusers = this.$store.state.allusers);
    // },
    // sentreqes() {
    //   return (this.sentreq = this.$store.state.sentreqs);
    // },
    // receivedreqs() {
    //   return (this.receivedreq = this.$store.state.receivedreqs);
    // },
  },
  methods: {
    modals(toToggle) {
      if (toToggle == "upload") {
        this.viewupload = !this.viewupload;
      } else if (toToggle == "alluser") {
        this.allu = !this.allu;
      } else if (toToggle == "pop") {
        this.isActive = !this.isActive;
      } else if (toToggle == "myprofile") {
        this.maprofile = !this.maprofile;
      } else if (toToggle == "allchatusers") {
        this.chatusers = !this.chatusers;
      }
    },
    sendmessage(cto) {
      // var time = new Date();
      // var hrs = time.getHours();
      // var min = time.getMinutes();
      // this.messages.push({ msg: this.message, time: `${hrs}:${min}` });
      // this.message = null;
      this.$store
        .dispatch("sendmessage", {
          from: this.loggeduser.id,
          msg: this.message,
          msgto: cto.id,
        })
        .then((resp) => {
          console.log(resp.data);
        })
        .catch((err) => console.log(err));
      this.message = null;
      this.allmessages();
      this.recentchat();
    },
    conservation(a) {
      this.chat = a;
      this.allmessages();
    },
    splitTime(time) {
      return time.split(" ")[1];
    },
    timeFormat(time) {
      let hours = time.split(":")[0];
      let minutes = time.split(":")[1];
      let ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "" + minutes : minutes;
      let strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    paccordion(acc) {
      if (acc == "pinfo") {
        this.vpersonalinfo = !this.vpersonalinfo;
      } else if (acc == "priv") {
        this.vprivacy = !this.vprivacy;
      } else if (acc == "freq") {
        this.vfreq = !this.vfreq;
      } else if (acc == "sreq") {
        this.vsreq = !this.vsreq;
      } else if (acc == "not") {
        this.vnotif = !this.vnotif;
      }
    },
    vothersprofile(viewpro, user) {
      if (viewpro == "stranger") {
        this.strangerprofile = true;
        this.stranger = user;
      } else if (viewpro == "friend") {
        this.othersprofile = true;
      }
    },
    closeoprofile(closepro) {
      if (closepro == "stranger") {
        this.strangerprofile = false;
        this.stranger = null;
      } else if (closepro == "friend") {
        this.othersprofile = false;
      }
    },
    activeuserr() {
      if (localStorage.getItem("activeuser")) {
        this.$store.state.activeuser = JSON.parse(
          localStorage.getItem("activeuser")
        );
        this.$router.push("/chat");
      } else {
        this.$router.push("/");
      }
    },
    pullusers() {
      this.$store
        .dispatch("pullusers", { from: this.loggeduser.id })
        .then((response) => {
          this.allusers = response.data;
        });
    },
    addfriend(stranger, loggeduser) {
      this.$store.dispatch("addfriend", {
        from: loggeduser.id,
        to: stranger.id,
      });
      this.sentrequests();
      this.pullusers();
    },
    sentrequests() {
      this.$store
        .dispatch("sentreq", { from: this.loggeduser.id })
        .then((response) => {
          this.sentreq = response.data;
        });
    },
    receivedrequests() {
      this.$store
        .dispatch("receivedreq", { from: this.loggeduser.id })
        .then((response) => {
          this.receivedreq = response.data;
        });
    },
    befriends(userid) {
      this.$store.commit("befriends", { from: userid.ffromid });
      this.receivedrequests();
    },
    befriendss(stranger) {
      this.$store
        .dispatch("befriendss", { from: stranger.frfrom, to: stranger.frto })
        .then((response) => {
          console.log(response.data);
        });
      this.receivedrequests();
      this.pullusers();
    },
    myfriends() {
      this.$store
        .dispatch("myfriends", { from: this.loggeduser.id })
        .then((resp) => (this.friends = resp.data))
        .catch((err) => err);
    },
    recentchat() {
      setInterval(() =>{
        this.$store
          .dispatch("recentchats", { from: this.loggeduser.id })
          .then((resp) => (this.recentcons = resp.data))
          .catch((err) => err);
      },1000)
    },
    allmessages() {
      setInterval(() =>{
        this.$store
          .dispatch("allmessages", { from: this.loggeduser.id, to: this.chat.id })
          .then((resp) => {
            this.messages = resp.data;
            var cont = document.getElementById("chatz");
            cont.scrollTop = cont.scrollHeight;
          });
      },1000)
    },
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
  },
  mounted() {
    this.activeuserr();
    this.pullusers();
    this.sentrequests();
    this.receivedrequests();
    this.myfriends();
    this.recentchat();
  },
  afterMount(){
    let cont = document.getElementById("chatz");
    cont.scrollTop = cont.scrollHeight;
  },
  watch: {
    messages() {
      var cont = document.getElementById("chatz");
      cont.scrollTop = cont.scrollHeight;
    },
  },
};
</script>
  <style lang="scss" scoped>
$darkbg: #2b2b2b;
$color: #8f9198;
.chats {
  &::-webkit-scrollbar {
    width: 4px;
    background: #1f1f1f;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #2b2b2b;
  }
}
.router-link-active {
  position: relative;
  &::before {
    position: absolute;
    content: "";
    top: 0;
    width: 2px;
    height: 100%;
    background: #4eac6d;
  }
}
.popup {
  pointer-events: all;
  opacity: 1;
  transform: translateY(0px);
}
.popupx {
  pointer-events: all;
  opacity: 1;
  transform: translateX(0px);
}
.resend-enter-from,
.resend-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.resend-enter-active,
.resend-leave-active {
  transition: all 0.6s ease;
}
.semess-enter-from,
.semess-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
.semess-enter-active,
.semess-leave-active {
  transition: all 0.6s ease;
}
.dropit {
  height: auto;
  opacity: 1;
  transition: 0.7s;
}
</style>